import React from 'react'
import HeadData from 'components/Common/HeadData'

export function decodeFromUrlString(urlLocation: string) {
  return decodeURIComponent(urlLocation)
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function CruiseDeparturesPageHeadData(props: { place: App.Place }) {
  const { place } = props
  const location = place.name
  const countryName = place.canonicalName?.split(',')?.pop()?.replace(' ', '') ?? ''
  const currentYear = new Date().getFullYear()
  const title = `Cruises from ${place.name} | Best Deals ${currentYear} - ${currentYear + 1}`
  let description = ''
  if (countryName) {
    description = `Discover cruises departing from ${location}, ${countryName}. Book now and save more with our exclusive offers to top destinations`
  } else {
    description = `Discover cruises departing from ${location}. Book now and save more with our exclusive offers to top destinations`
  }

  return <HeadData title={title} description={description} />
}

export function CruiseDestinationsHeadData(props: { destination: string }) {
  const { destination } = props
  const currentYear = new Date().getFullYear()
  const title = `Cruises to ${destination} | Best Deals ${currentYear} - ${currentYear + 1}`
  const description = `Embark on a cruise to ${destination} with Luxury Escapes. Browse our wide variety of exclusive deals and curated extras to make your cruise unforgettable.`

  return <HeadData title={title} description={description} />
}

export function CruiseShipsHeadData(props: { shipName: string }) {
  const { shipName } = props
  const currentYear = new Date().getFullYear()
  const title = `${shipName} | Best Deals ${currentYear}/${currentYear + 1}/${currentYear + 2}`
  const description = `Set sail on ${shipName} with exclusive deals from Luxury Escapes. Reserve your stateroom before it sells out.`

  return <HeadData title={title} description={description} />
}
